import React, { Component } from "react";
import Button from "../../../button-classic/button-classic";
import "../../../route_code/route_code.less";
import { setItemToSessionStorage } from "Utils/sessionStorage";
import InputText from "../../../../common/components/input-text/input-text";
import Cx from "classnames";
import Select from "react-select";

class AddRfDeviceMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        device_location: this.props.editData ? this.props.editData.device_location : "",
        device_location_id: this.props.editData ? this.props.editData.device_location_id : "",
        plant_name: this.props.editData ? this.props.editData.plant_name : "",
        plant_code: this.props.editData ? this.props.editData.plant_code : "",
        rf_id: this.props.editData ? this.props.editData.rf_id : "",
        device_id: this.props.editData
          ? this.props.editData.device_id
          : "",
        device_name: this.props.editData ? this.props.editData.device_name : "",
        company_id: this.props.editData
          ? this.props.editData.company_id
          : this.props.companyId,
        branch_id: this.props.editData
          ? this.props.editData.branch_id
          : this.props.branchId,
        detail_id: this.props.editData
          ? this.props.editData.detail_id
          : "",
        gate_no: this.props.editData
          ? this.props.editData.gate_no
          : "",
      },
    };
  }

  componentDidMount() {
    setItemToSessionStorage("previousRfDeviceMasterData", this.props.editData);
  }

  onChangeHandler = (value, id) => {
    let { data } = this.state;
    data[id] = value;
    this.setState({ data });
  };

  onSave = () => {
    const { data } = this.state;
    this.props.onSave(data);
  };

  onUpdate = () => {
    const { data } = this.state;
    this.props.onUpdate(data);
  };


  onChangeRfDeviceLocationName = (e) => {
    let { data } = this.state;
    data.device_location =  e.label;
    data.device_location_id = e.value;
    const isGateLocation =
      data.device_location === "Gate-OUT" ||
      data.device_location === "Gate-IN";
    if (!isGateLocation) {
      data.gate_no = "";
    }
    this.setState({ data });
  };

  disableSaveUpdateButton = () => {
    const { data } = this.state;
    const isGateLocation =
      data.device_location === "Gate-OUT" ||
      data.device_location === "Gate-IN";
    return (
      data.device_location_id &&
      data.plant_name &&
      data.plant_code &&
      data.device_id &&
      data.device_name &&
      data.rf_id &&
      (!isGateLocation || data.gate_no)
    );
  };

  render() {
    const { data } = this.state;
    const disable = !(this.disableSaveUpdateButton());

    let optionRfDeviceLocationName = [];

    if (this.props.indentingMoves) {
      optionRfDeviceLocationName = this.props.indentingMoves.map((item) => ({
        value: item.move_id,
        label: item.name,
        device_location: item.name,
        device_location_id: item.move_id,
      }));
    }

    return (
      <div className="route_code_detail">
        <div onClick={this.props.toggleAdd} className="overlay"></div>
        <div id="modal" className="modal-popup" style={{ minHeight: "600px" }}>
          <div className="pop-heading">

            {`${this.props.editData ? "Edit" : "Add"} RF Device Master`}
          </div>
          <div className="route-detail">
            <div
              className="details-section"
              style={{ display: "flex", gap: "30px" }}
            >

              <div style={{ display: "flex", flexDirection: "column" }}>
                  <div className="label">Device Location <span className="error-color">*</span></div>
                      <Select
                        className={Cx("selectpack")}
                        options={optionRfDeviceLocationName}
                        value={optionRfDeviceLocationName.find(
                          (val) => val.value == data.device_location_id
                        )}
                        onChange={(e) => this.onChangeRfDeviceLocationName(e)}
                      />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"plant_name"}
                  label="Plant Name"
                  changeHandler={(value) => this.onChangeHandler(value, "plant_name")}
                  value={data["plant_name"]}
                  required={true}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"plant_code"}
                  label="Plant Code"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "plant_code")
                  }
                  value={data["plant_code"]}
                  required={true}
                />
              </div>
            </div>

            <div
              className="details-section"
              style={{ display: "flex", gap: "30px", marginTop: "20px" }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"rf_id"}
                  label="Rf Id"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "rf_id")
                  }
                  value={data["rf_id"]}
                />
              </div>
              <div>
                <InputText
                  placeholder=""
                  id={"device_id"}
                  label="Device Id"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "device_id")
                  }
                  value={data["device_id"]}
                  required={true}
                />
              </div>
              <div>
                <InputText
                  placeholder=""
                  id={"device_name"}
                  label="Device Name"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "device_name")
                  }
                  value={data["device_name"]}
                  required={true}
                />
              </div>
            </div>
            <div
              className="details-section"
              style={{ display: "flex", gap: "30px", marginTop: "20px" }}
            >
              {(data.device_location === "Gate-OUT"||data.device_location === "Gate-IN") && (
                  <InputText
                    placeholder=""
                    id={"gate_no"}
                    label="Gate No."
                    changeHandler={(value) =>
                      this.onChangeHandler(value, "gate_no")
                    }
                    value={data["gate_no"]}
                    required={true}
                  />
                )
              }
            </div>
            <div className={"button_route"} style={{ marginTop: "50px" }}>
              <Button value={"Cancel"} click={this.props.toggleAdd} />
              {!this.props.editData ? (
                <Button value={"Save"} click={this.onSave} disabled={disable} />
              ) : (
                <Button
                  value={"Update"}
                  click={this.onUpdate}
                  disabled={disable}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddRfDeviceMaster;
